import { SITE_NAME } from '../../utils/seoConstants';

export const HowToBookSchema = () => {
  const schema = {
    "@context": "https://schema.org",
    "@type": "HowTo",
    "name": `How to Book a Tutor on ${SITE_NAME}`,
    "description": "Book your first online tutoring session in 3 easy steps. Find expert tutors for mathematics, science, languages, coding, and more.",
    "totalTime": "P5M",
    "step": [
      {
        "@type": "HowToStep",
        "name": "Post Your Requirement",
        "text": "Fill out a quick form with your learning needs, preferred subject, grade level, and schedule availability.",
        "position": 1
      },
      {
        "@type": "HowToStep",
        "name": "Match with a Tutor",
        "text": "Our system matches you with qualified tutors based on your requirements. Review tutor profiles and ratings.",
        "position": 2
      },
      {
        "@type": "HowToStep",
        "name": "Book Your Free Trial",
        "text": "Schedule your first free trial class with your chosen tutor and start your personalized learning journey!",
        "position": 3
      }
    ]
  };

  return (
    <script
      key="howto-schema"
      type="application/ld+json"
      dangerouslySetInnerHTML={{ __html: JSON.stringify(schema) }}
    />
  );
};

export default HowToBookSchema;
